import Vue from 'vue';

import MdNotification from '@/js/components/md/Notification';
import MyoSidebar from '@/js/components/myo/Sidebar';
import MyoInput from '@/js/components/myo/Input';
import MyoParameters from '@/js/components/myo/Parameters';

Vue.component('md-notification', MdNotification);
Vue.component('myo-sidebar', MyoSidebar);
Vue.component('myo-input', MyoInput);
Vue.component('myo-parameters', MyoParameters);



// WEBPACK FOOTER //
// ./src/js/components.js